<template>
    <div class="skills" id="skills">
        <h1 class="text-center">Frontend</h1>
        <hr>
        <div class="row my-3">
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/bootstrap.png" alt="">
            </div>
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/css3.png" alt="">
            </div>
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/html5.png" alt="">
            </div>
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/js.png" alt="">
            </div>
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/vue.png" alt="">
            </div>
            <div class="col col-lg-4 col-md-4 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/jquery.png" alt="">
            </div>
        </div>
        <h1 class="text-center">Backend</h1>
        <hr>
        <div class="row my-3">
            <div class="col col-lg-3 col-md-3 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/laravel.png" alt="">
            </div>
            <div class="col col-lg-3 col-md-3 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/mysql.png" alt="">
            </div>
            <div class="col col-lg-3 col-md-3 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/ci.png" alt="">
            </div>
            <div class="col col-lg-3 col-md-3 col-sm-6
            d-flex justify-content-center">
                <img src="../assets/skills/postgre.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Skills',
    components: {

    }
}
</script>
<style lang="scss" scoped>
.skills {
    padding: 50px 50px;
    .row {
        .col {
            margin: 30px 0px;
        }
        img {
            width: 150px;
            height: 120px;
        }
    }
}
</style>